export default __webpack_public_path__ + "static/media/crew-08.835690f2.svg";